import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UploadService } from './upload.service';
import { ISOXMLService } from './ISOXML/ISOXML.service';
// import JSZip from 'jszip';

@Injectable()
export class FileManagementService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(
    private http: HttpClient,
    private uploadService: UploadService,
    private isoxmlService: ISOXMLService
  ) {}

  getPolygonFromFile(fileType, file) {
    if (fileType == 'shp') {
      // let zip = new JSZip();
      // zip.file(file);
      this.uploadService.saveFile(file).subscribe((res) => {
        this.http
          .get<any>(this.apiBaseUrl + 'api/private/v1/satellite/shapeToGeojson?url=' + res)
          .pipe(map((response) => response))
          .subscribe((shape) => {
            return shape;
          });
      });
    } else if (fileType == 'kml') {
      this.kmlToGeoJson(file).subscribe((res) => {
        return res;
      });
    } else if (fileType == 'kmz') {
      //open kmz and call kml method
    } else if (fileType == 'xml') {
      console.log('case xml');
      this.isoxmlService.ISOXMLFile2Fields(file, file.type).then((fields) => {
        //manage only one field
        console.log('field-->', fields);
        if (fields.length == 0) {
          return null;
        }
        const f = fields[0];
        const goeJsonFieldNew = JSON.parse(f.geoJsonArea);
        return goeJsonFieldNew;
      });
    } else {
      return null;
    }
  }

  kmlToGeoJson(file): Observable<any> {
    return this.http
      .post(this.apiBaseUrl + 'api/private/v1/kmlToGeoJson', file)
      .pipe(map((response) => response));
  }

  shapeToGeoJson(url): Observable<any> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/satellite/shapeToGeojson?url=' + url)
      .pipe(map((response) => response));
  }
}
